import { MediaDeviceRepository, MediaDeviceStatusListener, MediaDeviceStatusErrorListener } from 'core/repositories/MediaDeviceRepository';
import { MediaDevice } from 'core/models/mediaDevice';
import { Project } from 'core/models/project';

class DummyMediaDeviceRepository implements MediaDeviceRepository {
    addStatusListener(_mediaDeviceId: MediaDevice.Id, _projectId: Project.Id, listener: MediaDeviceStatusListener): void {
        listener({ started: true });
    }

    removeStatusListener(_mediaDeviceId: MediaDevice.Id, _projectId: Project.Id, listener: MediaDeviceStatusListener): void {
        listener({ started: true });
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addMediaDeviceStatusErrorListener(_listener: MediaDeviceStatusErrorListener) {
        // nothing to do
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeMediaDeviceStatusErrorListener(_listener: MediaDeviceStatusErrorListener) {
        // nothing to do
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async startPublish(_mediaDeviceId: MediaDevice.Id) {
        // nothing to do
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async stopPublish(_mediaDeviceId: MediaDevice.Id) {
        // nothing to do
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async restartPublish(_mediaDeviceId: MediaDevice.Id) {
        // nothing to do
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getVideoParams(_mediaDeviceId: MediaDevice.Id, _projectId: Project.Id): Promise<Partial<MediaDevice.VideoConfig>> {
        throw new Error('Method not implemented.');
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async setVideoParams(_mediaDeviceId: MediaDevice.Id, _projectId: Project.Id, _environmentId: string, _videoParams: Partial<MediaDevice.VideoConfig>) {
        // nothing to do
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getAudioParams(_mediaDeviceId: MediaDevice.Id, _projectId: Project.Id): Promise<Partial<MediaDevice.AudioConfig>> {
        throw new Error('Method not implemented.');
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async setAudioParams(_mediaDeviceId: string, _projectId: string, _environmentId: string, _audioParams: Partial<MediaDevice.AudioConfig>): Promise<void> {
        // nothing to do
    }
}

export { DummyMediaDeviceRepository as MediaDeviceRepository };
